import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import Loading from "@/app/core/layouts/main/components/Loading";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import { ComplainHelper } from "@/app/core/util/helpers/ComplainHelper";
import { CnpjMask } from "@/app/core/util/helpers/FieldHelper";
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

export default function EmpresaComponent(props){

  const [data, setData] = useState([]);
  const [company, setCompany] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    loadCompany()
  },[])
  
  async function loadCompany(){
    CompanyController.Get(props.match.params.key, res => setCompany(res));
    const infos = await ComplainController.ListByCompany(props.match.params.key);
    
    console.log("Dados", infos)
    
    setData(infos.filter(x => x.status != ComplainHelper.Status.Pending && x.status != ComplainHelper.Status.Deleted));
  }

  function openComplain(item){}

  return (
    <>
      {company && company.id ?
        <div className="block-content border block-bordered block-content-sm block-content-full bg-white">
          <div className="media py-3">
            <div className="mr-3 ml-2 overlay-container overlay-right">
              <img className="img-avatar img-avatar48" src={company.logo ? company.logo : "assets/media/avatars/avatar4.jpg"} alt="" />
            </div>
            <div className="media-body">
              <div className="row">
                <div className="col-sm-7">
                  <a className="font-w600 link-fx" href="be_pages_generic_profile.html">{company.name}</a>
                  <div className="font-size-sm text-muted">{CnpjMask(company.taxId)}</div>
                </div>
                <div className="col-sm-5 d-sm-flex align-items-sm-center">
                  <div className="font-size-sm font-italic text-muted text-sm-right w-100 mt-2 mt-sm-0">
                    <a type="button" className="btn btn-hero-warning text-dark" href={`#/reclamar/?empresa=${company.id}?name=${company.name}`}>
                        <i className="fa fa-bullhorn"/> Reclamar
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        : ""}
      <div className="row no-gutters justify-content-center mt-5 mb-10 ml-5 mr-5">
        <div className="col-md-8 pl-2 pr-2">
          {data && data.map(item => (
            <div className="block block-fx-pop block-rounded cursor" onClick={()=> openComplain(item)}>
              <div className="block-header mb-0">
                <div className="block-title">{item.title}</div>
                <div className="block-tools">{DateTranslate(item.createdDate.seconds* 1000)}</div>
              </div>
              <div className="block-content mt-0">
                <p style={{ whiteSpace: "pre-line" }}>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="col-md-4">
            <div className="block block-transparent block-bordered block-rounded">
                <div className="block-header">
                    <div className="block-title">
                        <i className="si si-star"/> Antes de reclamar:
                    </div>
                </div>
                <ul>
                    <li>Prepare imagens para reforçar a reclamação</li>
                    <li>Prepare um texto de pelo menos 5 linhas</li>
                </ul>

                <a type="button" className="btn btn-block btn-hero-warning text-dark" href={`#/reclamar/?empresa=${company && company.id}?name=${company.name}`}>
                        <i className="fa fa-bullhorn"/> Reclamar
                    </a>
            </div>
        </div>
      </div>
      <Loading loading={loading} />
      <ToastContainer className="toastr" />
    </>
  );
    
}